<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 248 350"
    preserveAspectRatio
  >
    <rect
      width="248"
      height="350"
      fill="#cfe9fc"
      fill-opacity="1"
      rx="25"
      ry="25"
    />
    <path
      fill="#78b6f0"
      d="M57.377 204.316A25 25 0 0 0 24.861 218.2L0 280.115V325a24.946 24.946 0 0 0 1.254 7.817l85.837-116.57Z"
    />
    <path
      fill="#447bff"
      d="M156.984 163.494a25 25 0 0 0-34.955 5.307l-34.938 47.446-85.837 116.57a24.718 24.718 0 0 0 1.5 3.582l.019.039a25.045 25.045 0 0 0 3.19 4.762l.057.066a25.111 25.111 0 0 0 2.607 2.622l.137.118q.692.592 1.425 1.136l.056.04q.714.522 1.466.994l.139.089q.75.465 1.535.876c.081.043.162.083.243.125a24.871 24.871 0 0 0 3.275 1.39c.108.037.214.074.322.109.551.18 1.11.344 1.677.487.082.02.166.037.249.057q.786.189 1.59.326c.095.017.189.036.285.051.577.092 1.162.162 1.752.214.127.011.255.02.382.029.608.045 1.221.075 1.84.075h198a25 25 0 0 0 25-25v-94.489Z"
    />
    <circle cx="64" cy="77" r="25" fill="#447bff" />
  </svg>
</template>
<script>
export default {
  name: 'FileIcon'
};
</script>
